export default __webpack_public_path__ + "static/media/cottage_bread.86eb16c2.jpg";